export default function initQuickCart(nautilusData) {
    
    // DOM Elements - Quick Cart
    const quickCart = document.getElementById('nautilus-quick-cart');
    const closeBtn = document.getElementById('close-quick-cart');
    const cartItemsContainer = document.getElementById('cart-items');
    const cartItemTemplate = document.getElementById('cart-item-template');
    const loadingIndicator = document.getElementById('cart-loading');
    const emptyCartMessage = document.getElementById('cart-empty');
    const cartFooter = document.getElementById('cart-footer');
    const remainingForFreeShipping = document.getElementById('remaining-for-free-shipping');
    const freeShippingProgress = document.getElementById('free-shipping-progress');
    const freeShippingAchieved = document.getElementById('free-shipping-achieved');
    const cartTotal = document.getElementById('cart-total');
    const proceedToCheckout = document.getElementById('proceed-to-checkout');
    const openCartBtns = document.querySelectorAll('.open-quick-cart');
    
    // DOM Elements - Checkout Cart (reuse same functionality)
    const checkoutCartItems = document.getElementById('checkout-cart-items');
    const checkoutLoadingIndicator = document.getElementById('checkout-cart-loading');
    
    
    // Cart state
    let isCartOpen = false;
    let isLoading = false;
    
    // Check if we're on checkout page
    const isCheckoutPage = document.body.classList.contains('woocommerce-checkout') || checkoutCartItems;
    
    // Initialize
    function init() {
        if (quickCart) {
            initQuickCartFunctionality();
        }
        
        if (isCheckoutPage) {
            initCheckoutCartFunctionality();
        }
    }
    
    // Initialize Quick Cart functionality
    function initQuickCartFunctionality() {
        // Add event listeners for cart toggle buttons
        openCartBtns.forEach(btn => {
            btn.addEventListener('click', openCart);
        });
        
        // Close cart button
        if (closeBtn) {
            closeBtn.addEventListener('click', closeCart);
        }
        
        // Close cart when clicking outside
        document.addEventListener('click', function(event) {
            if (isCartOpen && !quickCart.contains(event.target) && !event.target.closest('.open-quick-cart')) {
                closeCart();
            }
        });
        
        // Add mini cart updates when product is added to cart
        document.body.addEventListener('added_to_cart', function() {
            // Just refresh cart data without opening it
            refreshCart();
        });
        
        // Initialize header cart count by fetching current cart data
        fetchCartCount();
    }
    
    // Initialize Checkout Cart functionality
    function initCheckoutCartFunctionality() {
        attachCheckoutEventListeners();
    }
    
    // Attach event listeners to checkout cart items
    function attachCheckoutEventListeners() {
        // Use the same selectors but with checkout- prefix
        const containers = [
            document.getElementById('cart-items'), // Quick cart
            document.getElementById('checkout-cart-items') // Checkout
        ].filter(Boolean);
        
        containers.forEach(container => {
            // Quantity inputs
            container.querySelectorAll('.cart-item-quantity, .checkout-cart-item-quantity').forEach(input => {
                input.addEventListener('change', function() {
                    const cartItem = this.closest('.cart-item, .checkout-cart-item');
                    const cartItemKey = cartItem.dataset.cartItemKey;
                    const newQuantity = parseInt(this.value, 10);
                    const maxQty = parseInt(cartItem.dataset.maxQuantity, 10);
                    
                    if (newQuantity >= 0) {
                        if (newQuantity > maxQty) {
                            useToast(`Możesz dodać maksymalnie: ${maxQty}`, 'warning');
                            this.value = maxQty;
                            updateCartItem(cartItemKey, maxQty);
                        } else {
                            updateCartItem(cartItemKey, newQuantity);
                        }
                    }
                });
            });
            
            // Decrease buttons
            container.querySelectorAll('.cart-item-decrease, .checkout-cart-item-decrease').forEach(btn => {
                btn.addEventListener('click', function() {
                    const cartItem = this.closest('.cart-item, .checkout-cart-item');
                    const cartItemKey = cartItem.dataset.cartItemKey;
                    const quantityInput = cartItem.querySelector('.cart-item-quantity, .checkout-cart-item-quantity');
                    const currentQty = parseInt(quantityInput.value, 10);
                    const newQuantity = Math.max(0, currentQty - 1);
                    updateCartItem(cartItemKey, newQuantity);
                });
            });
            
            // Increase buttons
            container.querySelectorAll('.cart-item-increase, .checkout-cart-item-increase').forEach(btn => {
                btn.addEventListener('click', function() {
                    const cartItem = this.closest('.cart-item, .checkout-cart-item');
                    const cartItemKey = cartItem.dataset.cartItemKey;
                    const quantityInput = cartItem.querySelector('.cart-item-quantity, .checkout-cart-item-quantity');
                    const currentQty = parseInt(quantityInput.value, 10);
                    const maxQty = parseInt(cartItem.dataset.maxQuantity, 10);
                    const newQuantity = currentQty + 1;
                    
                    if (newQuantity > maxQty) {
                        useToast(`Możesz dodać maksymalnie: ${maxQty}`, 'warning');
                        return;
                    }
                    
                    updateCartItem(cartItemKey, newQuantity);
                });
            });
            
            // Remove buttons
            container.querySelectorAll('.cart-item-remove, .checkout-cart-item-remove').forEach(btn => {
                btn.addEventListener('click', function() {
                    const cartItem = this.closest('.cart-item, .checkout-cart-item');
                    const cartItemKey = cartItem.dataset.cartItemKey;
                    removeCartItem(cartItemKey);
                });
            });
        });
    }
    
    // Open cart
    function openCart() {
        if (isCartOpen || !quickCart) return;
        
        quickCart.classList.remove('translate-x-full');
        isCartOpen = true;
        document.body.style.overflow = 'hidden';
        
        refreshCart();
    }
    
    // Close cart
    function closeCart() {
        if (!isCartOpen || !quickCart) return;
        
        quickCart.classList.add('translate-x-full');
        isCartOpen = false;
        document.body.style.overflow = '';
    }
    
    // Refresh cart contents
    function refreshCart() {
        if (isLoading) return;
        
        setLoading(true);
        
        fetch(nautilusData.ajax_url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'nautilus_get_cart',
                nonce: nautilusData.nonce
            })
        })
        .then(response => response.json())
        .then(response => {
            if (response.success) {
                renderCart(response.data);
                updateHeaderCartCount(response.data.item_count);
            } else {
                console.error('Error fetching cart:', response);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        })
        .finally(() => {
            setLoading(false);
        });
    }
    
    // Update cart item quantity with validation
    function updateCartItem(cartItemKey, quantity) {
        if (isLoading) return;
        
        // Find the product data to check max quantity
        const cartItem = document.querySelector(`[data-cart-item-key="${cartItemKey}"]`);
        const rawMaxQuantity = cartItem ? parseInt(cartItem.dataset.maxQuantity) : null;
        const maxQuantity = (rawMaxQuantity && rawMaxQuantity > 0) ? rawMaxQuantity : 999;
        
        // Validate quantity
        if (quantity < 0) quantity = 0;
        if (quantity > maxQuantity) {
            useToast(`Możesz dodać maksymalnie: ${maxQuantity}`, 'warning');
            quantity = maxQuantity;
            // Update the input field to show the corrected value
            const quantityInput = cartItem.querySelector('.cart-item-quantity, .checkout-cart-item-quantity');
            if (quantityInput) quantityInput.value = quantity;
        }
        
        setLoading(true);
        
        fetch(nautilusData.ajax_url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'nautilus_update_cart_item',
                nonce: nautilusData.nonce,
                cart_item_key: cartItemKey,
                quantity: quantity
            })
        })
        .then(response => response.json())
        .then(response => {
            if (response.success) {
                if (isCheckoutPage) {
                    // On checkout page, reload to update WooCommerce checkout
                    window.location.reload();
                } else {
                    // In quick cart, just update the cart display
                    renderCart(response.data);
                    updateHeaderCartCount(response.data.item_count);
                }
            } else {
                console.error('Error updating cart item:', response);
                if (response.data && response.data.message) {
                    useToast(response.data.message, 'error');
                }
            }
        })
        .catch(error => {
            console.error('Error:', error);
            useToast('Wystąpił błąd podczas aktualizacji koszyka', 'error');
        })
        .finally(() => {
            setLoading(false);
        });
    }
    
    // Remove cart item
    function removeCartItem(cartItemKey) {
        if (isLoading) return;
        
        setLoading(true);
        
        fetch(nautilusData.ajax_url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'nautilus_remove_cart_item',
                nonce: nautilusData.nonce,
                cart_item_key: cartItemKey
            })
        })
        .then(response => response.json())
        .then(response => {
            if (response.success) {
                useToast('Produkt został usunięty z koszyka', 'success');
                if (isCheckoutPage) {
                    // On checkout page, reload to update WooCommerce checkout
                    window.location.reload();
                } else {
                    // In quick cart, just update the cart display
                    renderCart(response.data);
                    updateHeaderCartCount(response.data.item_count);
                }
            } else {
                console.error('Error removing cart item:', response);
                useToast('Wystąpił błąd podczas usuwania produktu', 'error');
            }
        })
        .catch(error => {
            console.error('Error:', error);
            useToast('Wystąpił błąd podczas usuwania produktu', 'error');
        })
        .finally(() => {
            setLoading(false);
        });
    }
    
    // Render cart contents (only for quick cart)
    function renderCart(cartData) {
        if (!cartItemsContainer) return; // Only render in quick cart
        
        // Clear existing items
        cartItemsContainer.innerHTML = '';
        
        if (cartData.items.length === 0) {
            // Show empty cart message
            emptyCartMessage.classList.remove('hidden');
            cartItemsContainer.classList.add('hidden');
            cartFooter.classList.add('hidden');
        } else {
            // Hide empty cart message
            emptyCartMessage.classList.add('hidden');
            cartItemsContainer.classList.remove('hidden');
            cartFooter.classList.remove('hidden');
            
            // Render each cart item
            cartData.items.forEach(item => {
                // Calculate max quantity with proper fallback
                const calculatedMaxQuantity = (() => {
                    const maxQty = item.max_quantity || item.stock_quantity;
                    return (maxQty && maxQty > 0) ? maxQty : 999;
                })();
                
                const itemElement = cartItemTemplate.content.cloneNode(true);
                
                // Set item data
                const itemLink = itemElement.querySelector('.cart-item-link');
                const itemImage = itemElement.querySelector('.cart-item-image');
                const itemName = itemElement.querySelector('.cart-item-name');
                const regularPrice = itemElement.querySelector('.regular-price');
                const currentPrice = itemElement.querySelector('.current-price');
                const quantityInput = itemElement.querySelector('.cart-item-quantity');
                const cartItem = itemElement.querySelector('.cart-item');
                
                // Set attributes and content
                itemLink.href = item.permalink;
                itemImage.src = item.image_url;
                itemImage.alt = item.name;
                itemName.textContent = item.name;
                itemName.href = item.permalink;
                quantityInput.value = item.quantity;
                quantityInput.max = calculatedMaxQuantity;
                
                // Update price display
                if (item.on_sale && item.regular_price) {
                    regularPrice.innerHTML = item.regular_price + ' zł';
                    currentPrice.innerHTML = item.price + ' zł';
                } else {
                    regularPrice.style.display = 'none';
                    currentPrice.innerHTML = item.price + ' zł';
                }
                
                // Store cart item key and max quantity as data attributes
                cartItem.dataset.cartItemKey = item.key;
                cartItem.dataset.maxQuantity = calculatedMaxQuantity;
                
                // Add the item to the container
                cartItemsContainer.appendChild(itemElement);
            });
            
            // Update footer data
            updateCartFooter(cartData);
            updateCartTotal(cartData);
            
            // Re-attach event listeners for the newly rendered items
            attachCheckoutEventListeners();
        }
    }
    
    // Update cart footer information
    function updateCartFooter(cartData) {
        if (!cartTotal) return; // Only update in quick cart
        
        // Update total
        cartTotal.textContent = cartData.total;
        
        // Update checkout URL
        if (proceedToCheckout) {
            proceedToCheckout.href = cartData.checkout_url;
        }
        
        // Free shipping progress
        if (cartData.is_free_shipping_eligible) {
            freeShippingProgress?.classList.add('hidden');
            freeShippingAchieved?.classList.remove('hidden');
        } else {
            freeShippingProgress?.classList.remove('hidden');
            freeShippingAchieved?.classList.add('hidden');
            
            // Update remaining amount
            if (cartData.remaining_for_free_shipping && remainingForFreeShipping) {
                remainingForFreeShipping.innerHTML = cartData.remaining_for_free_shipping;
            }
        }
    }

    // Update cart count in header
    function updateHeaderCartCount(count) {
        const cartCountElements = document.querySelectorAll('.cart-count, #cart-item-count');
        
        cartCountElements.forEach(element => {
            if (element) {
                element.textContent = count;
                element.classList.toggle('hidden', count === 0);
            }
        });
    }
    
    // Fetch cart count only
    function fetchCartCount() {
        fetch(nautilusData.ajax_url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'nautilus_get_cart',
                nonce: nautilusData.nonce
            })
        })
        .then(response => response.json())
        .then(response => {
            if (response.success) {
                updateHeaderCartCount(response.data.item_count);
            } else {
                console.error('Error fetching cart count:', response);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }
    
    // Update cart total display
    function updateCartTotal(cartData) {
        if (cartData.total && cartTotal) {
            cartTotal.innerHTML = cartData.total;
        }
    }
    
    // Set loading state
    function setLoading(loading) {
        isLoading = loading;
        
        // Handle quick cart loading
        if (loadingIndicator && cartItemsContainer) {
            if (loading) {
                loadingIndicator.classList.remove('hidden');
                cartItemsContainer.classList.add('hidden');
                emptyCartMessage?.classList.add('hidden');
                cartFooter?.classList.add('hidden');
            } else {
                loadingIndicator.classList.add('hidden');
            }
        }
        
        // Handle checkout cart loading
        if (checkoutLoadingIndicator && checkoutCartItems) {
            if (loading) {
                checkoutLoadingIndicator.classList.remove('hidden');
                checkoutCartItems.classList.add('opacity-50', 'pointer-events-none');
            } else {
                checkoutLoadingIndicator.classList.add('hidden');
                checkoutCartItems.classList.remove('opacity-50', 'pointer-events-none');
            }
        }
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
    // Return public methods
    return {
        refreshCart,
        updateCartItem,
        removeCartItem,
        openCart,
        closeCart
    };
}